const analytics = {
  state: { homepageDays: "30daysAgo" },
  reducers: {
    onHomePageDaysChange: (state, payload) => {
      return { ...state, homepageDays: payload };
    },
  },
  effects: () => ({}),
};
export default analytics;
